import dayjs from "dayjs";
import {
	FieldValues,
	UseControllerProps,
	useController
} from "react-hook-form";
import { ChangeEvent } from "react";

type StackDirection = "row" | "column";

export interface YearPickerProps<
	T extends FieldValues
> extends UseControllerProps<T> {
	width?: string | number;
	years?: number[];
	direction?: StackDirection;
}

const YearPicker = <T extends FieldValues>({
	width,
	years = Array.from({ length: 10 }, (_, index) => dayjs().year() - index),
	direction = "row",
	...controllerProps
}: YearPickerProps<T>) => {
	const {
		field: { name, ref, value, onBlur, onChange }
	} = useController(controllerProps);

	const handleSelectInputChange = (e: ChangeEvent<HTMLSelectElement>) => {
		const value = parseInt(e.target.value);
		onChange(value);
	};

	const selectId = `year-picker-${name}`;

	return (
		<div style={{ width: width ?? "100%" }}>
			<div>
				<div
					className={`flex ${direction === "row" ? "flex-row items-center" : "flex-col"}`}
				>
					<label
						htmlFor={selectId}
						className="font-normal m-0 whitespace-nowrap"
					>
						Year:
					</label>

					<select
						id={selectId}
						name={name}
						ref={ref}
						value={value ?? ""}
						onBlur={onBlur}
						onChange={handleSelectInputChange}
						className="w-full px-3 py-2 bg-white border border-border rounded-lg text-base focus:outline-none focus:ring-1 focus:ring-ring"
					>
						{years.map((year) => (
							<option key={year} value={year}>
								{year}
							</option>
						))}
					</select>
				</div>
			</div>
		</div>
	);
};

export default YearPicker;
